export default store => {
  return {
    path: "users",
    getComponent(nextState, cb) {
      const comp = require("./User").default;
      cb(null, comp);
    },
  };
};
